<template lang="pug">

.main-page
  template(v-if="hasPublications")
    .hero-section
      .hero-content
        .hero-icon
          v-icon(size="48" color="#64748b") mdi-calendar-clock
        .hero-title Расписание занятий
        .hero-subtitle Выберите категорию для просмотра

        .navigation-cards.mt-12.mobile-compact
          .nav-card(
            v-for="(item, index) in navigationItems"
            :key="index"
            @click="navigateTo(item.route)"
            :class="`nav-card--${item.color}`"
          )
            .nav-card__icon
              v-icon(size="28" color="#64748b") {{ item.icon }}
            .nav-card__title {{ item.title }}
            .nav-card__subtitle {{ item.subtitle }}
            .nav-card__arrow
              v-icon(color="#64748b") mdi-arrow-right

  .empty-state(v-else)
    .empty-icon
      v-icon(size="64" color="#757575") mdi-calendar-remove
    .empty-title Нет опубликованных занятий
    .empty-subtitle Расписание временно недоступно

</template>

<script>
import { mapGetters, mapState } from 'vuex'
import '@/common'

export default {
  computed: {
    ...mapState('bootstrap', ['hasPublications', 'showCabinets']),
    ...mapGetters('bootstrap', ['isSchool']),

    navigationItems() {
      const items = [
        {
          title: this.isSchool ? 'Классы' : 'Группы',
          subtitle: this.isSchool ? 'Расписание по классам' : 'Расписание по группам',
          icon: 'mdi-account-group',
          route: 'groups',
          color: 'blue'
        },
        {
          title: this.isSchool ? 'Учителя' : 'Преподаватели',
          subtitle: this.isSchool ? 'Расписание по учителям' : 'Расписание по преподавателям',
          icon: 'mdi-account-tie',
          route: 'teachers',
          color: 'green'
        }
      ]

      if (this.showCabinets) {
        items.push({
          title: this.isSchool ? 'Кабинеты' : 'Аудитории',
          subtitle: this.isSchool ? 'Расписание по кабинетам' : 'Расписание по аудиториям',
          icon: 'mdi-door',
          route: 'cabinets',
          color: 'purple'
        })
      }

      return items
    }
  },

  methods: {
    navigateTo(routeName) {
      this.$router.push({ name: routeName })
    }
  }
}
</script>

<style lang="sass" scoped>

.main-page
  background: #f8fafc
  position: relative

.hero-section
  display: flex
  align-items: center
  justify-content: center
  min-height: calc(100vh - 100px)
  padding: 60px 20px
  padding-top: 0
  position: relative
  z-index: 1

.hero-content
  text-align: center
  max-width: 800px
  padding-bottom: 40px

.hero-icon
  margin-bottom: 32px

.hero-title
  font-size: clamp(2rem, 4vw, 3rem)
  font-weight: 600
  color: #334155
  margin-bottom: 16px
  letter-spacing: -0.01em
  line-height: 1.2

.hero-subtitle
  font-size: 1.1rem
  color: #64748b
  margin-bottom: 48px

.navigation-cards
  display: flex
  flex-wrap: wrap
  justify-content: center
  align-items: stretch
  gap: 20px
  max-width: 1200px
  margin: 0 auto


.nav-card
  flex: 1
  min-width: 250px
  max-width: 300px
  height: auto
  min-height: 180px
  background: white
  border: 1px solid #e2e8f0
  border-radius: 8px
  padding: 32px 5px
  cursor: pointer
  transition: all 0.3s ease
  display: flex
  flex-direction: column
  align-items: center
  justify-content: space-between
  text-align: center
  box-shadow: 0 1px 3px rgba(0,0,0,0.1)
  touch-action: manipulation
  -webkit-tap-highlight-color: transparent

  // Hover effects only for devices with mouse
  @media (hover: hover)
    &:hover
      transform: translateY(-4px)
      box-shadow: 0 8px 25px rgba(0,0,0,0.15)
      border-color: #cbd5e1

      .nav-card__arrow
        transform: translateX(4px)

  // Active/pressed state for touch devices
  &:active
    transform: scale(0.98)
    box-shadow: 0 2px 8px rgba(0,0,0,0.15)

.nav-card__icon
  margin-bottom: 20px
  background: #f1f5f9
  border-radius: 50%
  width: 64px
  height: 64px
  display: flex
  align-items: center
  justify-content: center

.nav-card__title
  font-size: 1.25rem
  font-weight: 600
  color: #1e293b
  margin-bottom: 8px
  letter-spacing: -0.01em

.nav-card__subtitle
  font-size: 0.9rem
  color: #64748b
  margin-bottom: 20px
  line-height: 1.4
  height: 1.4em
  display: flex
  align-items: center
  justify-content: center

.nav-card__arrow
  transition: transform 0.3s ease
  opacity: 0.6
  color: #64748b

// Empty state
.empty-state
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  flex: 1
  text-align: center
  min-height: calc(100vh - 140px)
  padding: 40px 20px

.empty-icon
  margin-bottom: 24px
  opacity: 0.4

.empty-title
  font-size: 1.75rem
  font-weight: 600
  color: #334155
  margin-bottom: 12px

.empty-subtitle
  font-size: 1rem
  color: #64748b

// Animations removed for cleaner appearance

// Responsive
@media (max-width: 800px)
  .navigation-cards
    max-width: 100%
    padding: 0 20px

@media (max-width: 640px)
  .navigation-cards
    gap: 16px
    padding: 0 16px

    .nav-card
      flex: 1 1 240px
      min-width: 220px
      max-width: 100%

  .nav-card
    padding: 24px 20px

  .hero-title
    font-size: 2.5rem

  .hero-subtitle
    font-size: 1.1rem
    margin-bottom: 32px

@media (max-width: 480px)
  .navigation-cards
    gap: 12px
    padding: 0 20px

    &.mobile-compact
      margin-top: 24px !important

    .nav-card
      flex: 1 1 100%
      min-width: unset
      max-width: 400px
      min-height: 140px
      padding: 20px 16px

  .hero-section
    padding: 20px 20px

  .hero-icon
    margin-bottom: 16px

    .v-icon
      font-size: 40px !important

  .hero-title
    font-size: 1.8rem
    margin-bottom: 12px

  .hero-subtitle
    font-size: 1rem
    margin-bottom: 24px

  .nav-card__icon
    width: 48px
    height: 48px
    margin-bottom: 12px

  .nav-card__title
    font-size: 1.1rem
    margin-bottom: 6px

  .nav-card__subtitle
    font-size: 0.85rem
    margin-bottom: 16px

@media (max-width: 360px)
  .navigation-cards
    gap: 10px
    padding: 0 16px

    &.mobile-compact
      margin-top: 16px !important

    .nav-card
      min-height: 120px
      padding: 16px 12px

  .hero-section
    padding: 16px 16px

  .hero-icon
    margin-bottom: 12px

    .v-icon
      font-size: 32px !important

  .hero-title
    font-size: 1.6rem

  .hero-subtitle
    font-size: 0.95rem
    margin-bottom: 20px
</style>
